<template>
  <div
    :class="[
      'p-1 d-flex align-items-center', {
        'bg-pale-danger': !isEmpty(event.extendedProps.deleted_at),
        'bg-pale-warning': isEmpty(event.extendedProps.deleted_at) && isEventUpdated,
      }
    ]"
  >
    <BAvatar
      :text="String(event.extendedProps.new_number_of_activities)"
      variant="outline-dark"
      size="24"
    />
    <span
      :class="[
        'mx-1 p-0 text-nowrap text-truncate text-dark font-weight-bolder'
      ]"
      v-text="event.title"
    />
  </div>
</template>
<script>
import { isEmpty } from 'lodash'
import moment from 'moment'

export default {
  name: 'ASMOfficerMonthlyPlansGridMonthView',

  props: {
    event: {
      type: Object,
      required: true
    }
  },

  emits: ['view', 'cancel'],

  computed: {
    isEventUpdated () {
      const eventDetails = this.event.extendedProps

      const createdAt = moment(eventDetails.created_at)
      const updatedAt = moment(eventDetails.updated_at)

      const eventDate = moment(`${eventDetails.event_date} ${createdAt.format('HH:mm:ss')}`)

      return updatedAt.isAfter(eventDate, 'seconds') && Number(eventDetails.is_modified) === 1
    }
  },

  methods: {
    isEmpty: isEmpty
  }
}
</script>
